import { defineDecimalPlaces } from '../../utils/round-functions/get-decimal-places';
import store from 'state/store';
import { calculateGlobalProcessingLimits, getGlobalBaseCurrencyInfo } from 'utils/helper-functions/limits-calculation';

interface ProfileCurrencyLimits {
  min_amount: number | null;
  max_amount: number | null;
  rate: number | null;
}

interface AvailableCurrency {
  code: string;
  min_amount: number;
  max_amount: number;
  rate?: number;
  crypto?: boolean;
}

export const getProfileLimitsForCurrency = (
  currencyCode: string,
  availableCurrencies: AvailableCurrency[] | null | undefined
): ProfileCurrencyLimits => {
  const state = store.getState();
  const chargeCurrency = state.payData?.currency;
  const baseCurrency = state.profileInfo?.base_currency;
  const isCurrencyConversion = chargeCurrency !== baseCurrency;
  const isBaseCurrencyLimit = currencyCode === baseCurrency;

  const { minLimit: availableProcessingCurrencyMin, maxLimit: availableProcessingCurrencyMax } = calculateGlobalProcessingLimits(chargeCurrency);
  const availableCurrencyMin = isCurrencyConversion && !isBaseCurrencyLimit
    ? availableProcessingCurrencyMin 
    : getGlobalBaseCurrencyInfo(isCurrencyConversion ? chargeCurrency : currencyCode || '')?.baseMinLimit;
  const availableCurrencyMax = isCurrencyConversion && !isBaseCurrencyLimit 
    ? availableProcessingCurrencyMax 
    : getGlobalBaseCurrencyInfo(isCurrencyConversion ? chargeCurrency : currencyCode || '')?.baseMaxLimit;

  const currencyInfo = availableCurrencies?.find(c => c.code === currencyCode);
  
  return {
    min_amount: availableCurrencyMin,
    max_amount: availableCurrencyMax,
    rate: currencyInfo?.rate ?? null
  };
};

export const getConvertedProfileLimits = (
  chargeCurrency: string,
  baseCurrency: string,
  availableCurrencies: AvailableCurrency[] | null | undefined
): ProfileCurrencyLimits => {
  if (chargeCurrency === baseCurrency) {
    return getProfileLimitsForCurrency(baseCurrency, availableCurrencies);
  }
  
  const chargeLimits = getProfileLimitsForCurrency(chargeCurrency, availableCurrencies);
  const baseLimits = getGlobalBaseCurrencyInfo(chargeCurrency);
  const chargeRate = chargeLimits.rate;
  
  if (!chargeRate) {
    return chargeLimits;
  }
  
  return {
    min_amount: baseLimits?.baseMinLimit,
    max_amount: baseLimits?.baseMaxLimit,
    rate: chargeRate
  };
};
